<dx-toolbar class="yo-toolbar">
  <dxi-item location="before">
    <div class="d-flex flex-row align-items-center">
      <div class="mg-l-5 mg-r-5">
        <yo-button
          class="mg-r-10"
          iconClass="fas fa-search-dollar"
          label="Générer des statistiques"
          (onClick)="displayExportSettings(currentIndex)"
          tooltip="Générer des statistiques de vente">
        </yo-button>
      </div>
    </div>
  </dxi-item>
</dx-toolbar>
<dx-tab-panel [(selectedIndex)]="currentIndex">
  <dxi-item [title]="'Analyse par prestation'">
    <dx-data-grid
      [dataSource]="analyseFinancierePrestation"
      [showBorders]="true"
      [showColumnLines]="true"
      [columnAutoWidth]="true"
      [hoverStateEnabled]="true"
      [allowColumnResizing]="true"
      [rowAlternationEnabled]="true"
      [showRowLines]="true"
      columnResizingMode="widget">

      <dxo-search-panel [visible]="true"></dxo-search-panel>
      <dxo-pager
        [showPageSizeSelector]="true"
        [allowedPageSizes]="[10, 20, 50, 100]"
      >
      </dxo-pager>
      <dxo-grouping
        [contextMenuEnabled]="true">
      </dxo-grouping>
      <dxo-header-filter [visible]="true"></dxo-header-filter>
      <dxo-group-panel
        [visible]="true">
      </dxo-group-panel>
      <dxi-column
        [allowHeaderFiltering]="true"
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="pointDeFacturation"
        caption="Point de facturation">
      </dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="pointDeLivraison"
        caption="Point de livraison"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="prestation"
        caption="Prestation"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="regime"
        caption="Régime"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="repas"
        caption="Repas"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="dateMenu"
        caption="Date menu"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="margeReel"
        headerCellTemplate="margeReelHeader"
        caption="Marge réelle (en %)">
        <div *dxTemplate="let data of 'margeReelHeader'"
             title="Proportion de l'écart entre Prix de prestation et CM réél VS Prix de prestation">
          {{ data.column.caption }}
        </div>
      </dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        headerCellTemplate="rentabiliteReelHeader"
        dataField="rentabiliteReel"
        caption="Marge réelle (en montant)"
      >
        <div *dxTemplate="let data of 'rentabiliteReelHeader'"
             title="Ecart entre CA Réél et CM Réel (Montant sorties validées)">
          {{ data.column.caption }}
        </div>
      </dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        cellTemplate="variationPercTemplate"
        headerCellTemplate="variationPercTemplateHeader"
        dataField="variationPerc"
        caption="Variation marge en %"
      ></dxi-column>
      <div *dxTemplate="let data of 'variationPercTemplateHeader'"
           title="Ecart entre marge prévue et réelle">
        {{ data.column.caption }}
      </div>

      <div *dxTemplate="let cell of 'variationPercTemplate'">
        <span
          [style.color]="cell.data.rentabiliteReel >= cell.data.rentabilitePrevisionnel ? '#89bc27' : '#fc004d'">{{ cell.value }}</span>
      </div>
    </dx-data-grid>

  </dxi-item>
  <dxi-item [title]="'Analyse par plat'">
    <dx-data-grid
      [dataSource]="analyseFinancierePlat"
      [showBorders]="true"
      [showColumnLines]="true"
      [columnAutoWidth]="true"
      [hoverStateEnabled]="true"
      [allowColumnResizing]="true"
      [rowAlternationEnabled]="true"
      [showRowLines]="true"
      columnResizingMode="widget">
      <dxo-search-panel [visible]="true"></dxo-search-panel>
      <dxo-pager
        [showPageSizeSelector]="true"
        [allowedPageSizes]="[10, 20, 50, 100]">
      </dxo-pager>
      <dxo-grouping
        [contextMenuEnabled]="true">
      </dxo-grouping>
      <dxo-header-filter [visible]="true"></dxo-header-filter>
      <dxo-group-panel
        [visible]="true">
      </dxo-group-panel>
      <dxi-column
        [allowHeaderFiltering]="true"
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="pointDeLivraison"
        caption="Point de livraison">
      </dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="prestation"
        caption="Prestation"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="regime"
        caption="Régime"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="repas"
        caption="Repas"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="decoupageRepas"
        caption="Découpage repas"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="plat"
        caption="Plat"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="dateMenu"
        caption="Date menu"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        headerFilter="ecartCMTheoriqueVsReelPercHeader"
        dataField="ecartCMTheoriqueVsReelPerc"
        caption="Ecart CM réel vs théorique (en %)"
      >
        <div *dxTemplate="let data of 'ecartCMTheoriqueVsReelPercHeader'"
             title="Coût matière réél basé sur le montant des sorties validées VS Coût de revient théorique du menu">
          {{ data.column.caption }}
        </div>
      </dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        headerCellTemplate="margeReelHeader"
        dataField="margeReel"
        caption="Marge réelle (en %)"
      >
        <div *dxTemplate="let data of 'margeReelHeader'"
             title="Proportion de l'écart entre Prix du plat et CM réél VS Prix du plat">
          {{ data.column.caption }}
        </div>
      </dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        headerCellTemplate="rentabiliteReelHeader"
        dataField="rentabiliteReel"
        caption="Marge réelle (en montant)"
      >
        <div *dxTemplate="let data of 'rentabiliteReelHeader'"
             title="Ecart entre CA Réél et CM Réel (Montant sorties validées)">
          {{ data.column.caption }}
        </div>
      </dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        cellTemplate="variationPercTemplate"
        headerCellTemplate="variationPercTemplateHeader"
        caption="Variation marge en %"
        dataField="variationPerc"
      ></dxi-column>
      <div *dxTemplate="let data of 'variationPercTemplateHeader'"
           title="Ecart entre marge prévue et réelle">
        {{ data.column.caption }}
      </div>
      <div *dxTemplate="let cell of 'variationPercTemplate'">
        <span
          [style.color]="cell.data.rentabiliteReel >= cell.data.rentabilitePrevisionnel ? '#89bc27' : '#fc004d'">{{ cell.value }}
        </span>
      </div>
    </dx-data-grid>
  </dxi-item>
</dx-tab-panel>
<yo-analyse-financiere-export
  (currentIndexChange)="updateSelectedIndex($event)">
</yo-analyse-financiere-export>
